import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const RespawnRealStyled = styled.div`
    flex: 1;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    position: relative;
`;

export const RespawnRealTopStyled = styled.div`
    margin: 0 16px;
`;

export const RespawnRealBannerStyled = styled.div`
    margin: 0 auto;
    position: relative;
    margin-bottom: 24px;
    width: 8em;
    height: 8em;

    img {
        width: 100%;
        height: 100%;
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 25%;
        width: 64%;
        height: 1px;
        box-shadow: 0 9em 64px 8px rgba(201, 253, 8, 0.5);
    }

`;

export const RespawnRealDescrStyled = styled.div`
    margin-top: 24px;
    text-align: center;
`;

export const RespawnRealMeanStyled = styled.div`
    margin-top: 24px;

    .accordion {
        border: none;
    }

    .accordion-item {
        background-color: var(--color-surface);
        border-radius: var(--border-radius);
    }

    .accordion-button {
        background-color: var(--color-surface);
        color: var(--color-white-60);
        padding: 12px;
        display: flex;
        justify-content: center;
    }

    .accordion-body {
        color: var(--color-white-60);

        li::marker {
            color: var(--color-yellow);
        }

        span {
            color: var(--color-white-95);
        }
    }
`;

export const RespawnRealBottomStyled = styled.div`
    background-color: var(--color-surface);
    padding: 16px 16px 24px;
    border-radius: var(--border-radius);
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    margin-top: 24px;

    > .skeleton {
        height: 48px;
    }

    @media (max-width: ${BREAKPOINTS.medium}px) {
        border-radius: var(--border-radius) var(--border-radius) 0 0;
    }
`;

export const RespawnRealEquityStyled = styled.div`
    text-align: center;
    background-color: var(--color-surface-secondary);
    padding: 16px;
    border-radius: var(--border-radius);
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;

    margin-bottom: 16px;
    position: relative;

    > .skeleton {
        height: 48px;
    }
`;

export const RespawnRealContentStyled = styled.div`
`;
export const RespawnRealDepositInfoStyled = styled.div`
    position: absolute;
    top: 18px;
    right: 18px;
`;

export const RespawnRealEquityItemStyled = styled.div`
    div {
        font-size: 24px;
        font-weight: 600;
    }

    span {
        font-size: 12px;
        font-weight: 400;
        color: var(--color-white-60);
    }
`;

export const RespawnRealTimerStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 16px;
`;

export const RespawnRealSuccessStyled = styled.div`
    display: flex;
    gap: 32px;
    flex-direction: column;
    height: 100%;
    padding: 0 16px 24px;
`;

export const RespawnRealSuccessContentContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
`;

export const RespawnRealSuccessContentStyled = styled.div`
    display: flex;
    gap: 16px;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    border-radius: 282px;
    position: relative;
    > * {
        z-index: 1;
    }
`;

export const RespawnRealSuccessAmountContainerStyled = styled.div`
    display: flex;
    gap: 8px;
    flex-direction: column;
    align-items: center;
`;

export const RespawnRealSuccessAmountStyled = styled.div`
    padding: 8px 16px;
    border-radius: var(--border-radius);
    background-color: var(--color-background-secondary);
    font-weight: 600;
    font-size: 32px;
    
    .decimal {
        font-size: 24px;
    }
`;

export const RespawnRealSuccessNextStatusStyled = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const RespawnRealSuccessBlurBackground1Styled = styled.div`
    width: 282px;
    height: 260px;
    flex-shrink: 0;
    border-radius: 282px;
    opacity: 0.13;
    background: #F5F7FF;
    filter: blur(84px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
`;

export const RespawnRealSuccessBlurBackground2Styled = styled.div`
    width: 194px;
    height: 184px;
    flex-shrink: 0;
    filter: blur(62px);
    background: #8192E4;
    opacity: 0.16;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: rotate(12.008deg) translate(-50%, -50%);
    pointer-events: none;
`;

export const RespawnRealSuccessAnimationWrapperStyled = styled.div`
    width: 342px;
    height: 372px;
    position: absolute;
    top: 130px;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    pointer-events: none;
`;
